import { useEffect, useState } from "react";
import { baseAPIUrl } from "../../../Utils/BaseAPI"
import CreateOrEdit from "./CreateOrEdit";
import { useNavigate } from "react-router-dom";
import axios, { AxiosError, AxiosResponse } from "axios";
import Swal from "sweetalert2";
import './css/style.css';
import { Slot } from "./Interfaces/SlotType";
import LineType from "./Interfaces/LineInterface";

interface SubmitResponse {
    Error?: string,
    Id: number,
    Message: string,
    Success: boolean,
    Warning: boolean
}

const Create = () => {
    const formAction = `${baseAPIUrl}SaveLineConfiguration`;
    const [formData, setFormData] = useState<LineType>({
        id: 0,
        boxId: '',
        address: '',
        color: '',
        displayName: '',
        isArchived: false,
        locationInfo: '',
        name: '',
        slots: [],
        wareHouse: ''
    });
    
    const handleSubmit = (event: any) => {
        event.preventDefault();
        axios.post(formAction, formData)
            .then((result: AxiosResponse) => {
                if (result && result.data.Success) {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'center',
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        },
                        didClose: () => {
                            navigate('/configurations/linea');
                        }
                    })

                    Toast.fire({
                        icon: 'success',
                        title: 'Linea creata correttamente'
                    })
                } else {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'center',
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'error',
                        title: 'Errore nella creazione della linea'
                    })
                }
            })
            .catch((error: AxiosError) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'error',
                    title: 'Errore nella creazione della linea'
                })
            })
    };
    
    

    const navigate = useNavigate();

    /* useEffect(() => {
        
        const form = document.getElementById('form-create-line') as HTMLFormElement;
        form?.addEventListener('submit', (event: SubmitEvent) => {
            
            // navigate('configurations/linea/');

        });
    }, []); */

    return (
        <>
            <form className="form" onSubmit={handleSubmit} id="form-create-line">
                <CreateOrEdit formData={formData} setFormData={setFormData}></CreateOrEdit>
            </form>
        </>
    )
}

export default Create;
